import BalancesGrid from "./BalancesGrid";

/**
 * Renders the Balance Page
 * @returns {JSX.Element}
 * @constructor
 */
const BalancesPage = () => {
    return (
        <div>
            <BalancesGrid />
        </div>
    )
}

export default BalancesPage;
